import { BASE_URL } from 'constants/env';
import axios from 'axios';

export const BILLING_ONE_TIME_PAYMENT_THANKYOU = async () => {
  const res = await axios.post(BASE_URL + `/billing/onetime/thankyou`);
  return res.data;
};
